import styled, { css } from 'vue3-styled-components';

export const ManagePageContainer = styled.div`
    padding: 0 24px;
    margin-left: 260px;
    min-height: 100vh;
    background: #f8fafc;
    border-radius: 10px;
`;

export const MainContentWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 0;
`;

// 헤더 섹션
export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.div`
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 8px 0;
    }
    
    span {
        color: #64748b;
        font-size: 16px;
        font-weight: 400;
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ActionButton = styled.button`
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

export const RefreshButton = styled(ActionButton)`
    background: #0f4c5c;
    color: white;
    
    &:hover {
        background: #0a3a47;
    }
`;

export const PrimaryButton = styled(ActionButton)`
    background: #0f4c5c;
    color: white;
    
    &:hover {
        background: #0a3a47;
    }
`;

export const SecondaryButton = styled(ActionButton)`
    background: #fb8b24;
    color: white;
    
    &:hover {
        background: #e67e22;
    }
`;

export const SuccessButton = styled(ActionButton)`
    background: #10b981;
    color: white;
    
    &:hover {
        background: #059669;
    }
`;

// 이관 섹션 그리드
export const MigrationGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 24px;
    margin-bottom: 32px;
`;

export const MigrationCard = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
`;

export const CardHeader = styled.div`
    padding: 24px 32px 16px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const CardIcon = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    
    ${props => {
        switch (props.type) {
            case 'order':
                return `background: linear-gradient(135deg, #0f4c5c 0%, #0a3a47 100%);`;
            case 'stock':
                return `background: linear-gradient(135deg, #fb8b24 0%, #e67e22 100%);`;
            case 'recipients':
                return `background: linear-gradient(135deg, #10b981 0%, #059669 100%);`;
            case 'company':
                return `background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);`;
            case 'oxygen':
                return `background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);`;
            case 'diabetes':
                return `background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);`;
            default:
                return `background: linear-gradient(135deg, #64748b 0%, #475569 100%);`;
        }
    }}
`;

export const CardTitle = styled.div`
    h3 {
        font-size: 20px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 4px 0;
    }
    
    span {
        color: #64748b;
        font-size: 14px;
        font-weight: 400;
    }
`;

export const CardContent = styled.div`
    padding: 24px 32px;
`;

export const CardActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const UploadArea = styled.div`
    border: 2px dashed #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    margin-bottom: 16px;
    
    &:hover {
        border-color: #0f4c5c;
        background: rgba(15, 76, 92, 0.05);
    }
    
    &.dragover {
        border-color: #0f4c5c;
        background: rgba(15, 76, 92, 0.1);
    }
`;

export const UploadText = styled.div`
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 8px;
    
    strong {
        color: #374151;
        font-weight: 600;
    }
`;

export const FileInput = styled.input`
    display: none;
`;

// 진행 상황 표시
export const ProgressSection = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 32px;
`;

export const ProgressHeader = styled.div`
    padding: 24px 32px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ProgressTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
`;

export const ProgressContent = styled.div`
    padding: 24px 32px;
`;

export const ProgressGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
`;

export const ProgressCard = styled.div`
    background: #f8fafc;
    padding: 20px;
    border-radius: 12px;
    text-align: center;
    border: 2px solid;
    
    ${props => {
        switch (props.type) {
            case 'order':
                return `border-color: #0f4c5c;`;
            case 'stock':
                return `border-color: #fb8b24;`;
            case 'recipients':
                return `border-color: #10b981;`;
            case 'company':
                return `border-color: #8b5cf6;`;
            default:
                return `border-color: #64748b;`;
        }
    }}
`;

export const ProgressNumber = styled.div`
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 8px;
    
    ${props => {
        switch (props.type) {
            case 'order':
                return `color: #0f4c5c;`;
            case 'stock':
                return `color: #fb8b24;`;
            case 'recipients':
                return `color: #10b981;`;
            case 'company':
                return `color: #8b5cf6;`;
            default:
                return `color: #64748b;`;
        }
    }}
`;

export const ProgressLabel = styled.div`
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
`;

// 템플릿 다운로드 섹션
export const TemplateSection = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 32px;
`;

export const TemplateHeader = styled.div`
    padding: 24px 32px;
    border-bottom: 1px solid #f1f5f9;
`;

export const TemplateTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 8px 0;
`;

export const TemplateSubtitle = styled.p`
    color: #64748b;
    font-size: 14px;
    margin: 0;
`;

export const TemplateContent = styled.div`
    padding: 24px 32px;
`;

export const TemplateGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
`;

export const TemplateItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: #f8fafc;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    transition: all 0.2s ease;
    
    &:hover {
        background: #f1f5f9;
        border-color: #d1d5db;
    }
`;

export const TemplateInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const TemplateIcon = styled.div`
    width: 32px;
    height: 32px;
    background: #10b981;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
`;

export const TemplateName = styled.div`
    font-weight: 600;
    color: #374151;
    font-size: 14px;
`;

export const DownloadButton = styled.button`
    padding: 8px 12px;
    background: #10b981;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover {
        background: #059669;
        transform: translateY(-1px);
    }
`;

// 상태 표시
export const StatusBadge = styled.span`
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    
    ${props => {
        switch (props.status) {
            case 'success':
                return `
                    background: #dcfce7;
                    color: #166534;
                `;
            case 'error':
                return `
                    background: #fee2e2;
                    color: #dc2626;
                `;
            case 'processing':
                return `
                    background: #fef3c7;
                    color: #92400e;
                `;
            case 'pending':
                return `
                    background: #e0f2fe;
                    color: #0369a1;
                `;
            default:
                return `
                    background: #f1f5f9;
                    color: #475569;
                `;
        }
    }}
`;

// 알림 메시지
export const AlertMessage = styled.div`
    padding: 16px 20px;
    border-radius: 12px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    font-weight: 500;
    
    ${props => {
        switch (props.type) {
            case 'success':
                return `
                    background: #dcfce7;
                    color: #166534;
                    border: 1px solid #22c55e;
                `;
            case 'error':
                return `
                    background: #fee2e2;
                    color: #dc2626;
                    border: 1px solid #ef4444;
                `;
            case 'warning':
                return `
                    background: #fef3c7;
                    color: #92400e;
                    border: 1px solid #f59e0b;
                `;
            case 'info':
                return `
                    background: #e0f2fe;
                    color: #0369a1;
                    border: 1px solid #0ea5e9;
                `;
            default:
                return `
                    background: #f1f5f9;
                    color: #475569;
                    border: 1px solid #cbd5e1;
                `;
        }
    }}
`;

export const AlertIcon = styled.div`
    font-size: 20px;
`;

// 빈 상태 표시
export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
`;

export const EmptyStateIcon = styled.div`
    font-size: 64px;
    margin-bottom: 16px;
    opacity: 0.5;
`;

export const EmptyStateTitle = styled.h3`
    color: #6c757d;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
`;

export const EmptyStateText = styled.p`
    color: #adb5bd;
    margin: 4px 0;
    font-size: 14px;
`;

// 진행 상황 섹션에 추가된 요소들
export const ProgressSubtitle = styled.span`
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
`;

export const ProgressSummary = styled.div`
    margin-top: 16px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    border-radius: 12px;
    border: 1px solid #e2e8f0;
`;

export const SummaryText = styled.p`
    margin: 0;
    font-size: 14px;
    color: #475569;
    text-align: center;
    
    strong {
        color: #0f4c5c;
        font-weight: 600;
    }
`;